module.exports = __webpack_public_path__ + "static/media/report_analysis.cc4dea53.svg";